module.exports = __webpack_public_path__ + "img/online.4ed65b68.svg";